module.exports = __webpack_public_path__ + "static/logo-06@2x.4a14e040.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/company_images/logo-06@2x.png
// module id = 832
// module chunks = 168707334958949